import type { AiChatTurn } from "@intelligems/ig-types";

/** Finds the last assistant reply with text in an Atlas turn. */
export function readTurnReplyMessageId(turn: AiChatTurn): string | null {
  let replyMessageId: string | null = null;

  for (const node of turn.nodes) {
    for (const message of node.messages) {
      if (message.role !== "assistant") {
        continue;
      }
      for (const part of message.parts) {
        if (part.type === "text" && part.text.trim().length > 0) {
          replyMessageId = message.id;
        }
      }
    }
  }

  return replyMessageId;
}
